import { useEffect, useRef } from 'react'
import GoogleRecaptcha from 'react-google-recaptcha'
import Flex from '@talkdesk/cobalt-react-flex'

const InvisibleCaptcha = ({
  siteKey,
  instance,
  onRecaptchaRendered,
  onSubmit,
}) => {
  const isFirstRenderRef = useRef(true)

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false
      return
    }
    if (instance && instance.getValue()) {
      instance.reset()
    }
  })

  return (
    <Flex alignX='center'>
      <GoogleRecaptcha
        sitekey={siteKey}
        size='invisible'
        onChange={onSubmit}
        ref={onRecaptchaRendered}
      />
    </Flex>
  )
}

export default InvisibleCaptcha
